import React from 'react';

export class SearchItem extends React.Component {

  render(){

    const containerAttributes = this.props.attributes || {};

    const className = typeof containerAttributes.className === 'string' ?
      containerAttributes.className
        .split(" ")
        .map( o => o.trim() )
        .filter( o => o )
      : [];

    className.push("product-search-card");

    if(this.props.active)
      className.push("active-product");


    containerAttributes.className = className.join(" ");

    return (
      <div {...containerAttributes}>
        <div className={"search-image-container"}>
            { this.props.image && <img src={this.props.image} width={"100%"} alt={""}/> }
        </div>
        <div>
          <div>{ this.props.title }</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/item/SearchItem.js